// extracted by mini-css-extract-plugin
export default {"dashboardRoot":"token-dashboard_dashboardRoot__yy6Y5","rightPanel":"token-dashboard_rightPanel__xSF-v","tokenDashboard":"token-dashboard_tokenDashboard__2qv9u"};